import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'autoExeSelect',
  props: {
  modelValue: {
    type: String
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit

const realValue = computed(() => {
  return props.modelValue
})

const selectChange = (data: any) => {
  console.log('selectChange', data)
  emits('update:modelValue', data)
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    modelValue: realValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((realValue).value = $event)),
    placeholder: "请选择是否自动完成",
    onChange: selectChange
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_option, {
        value: "N",
        label: "否"
      }),
      _createVNode(_component_el_option, {
        value: "Y",
        label: "是"
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})